import { createContext, ReactNode, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { initializeContext as initContextInGUI } from '@oliasoft-open-source/react-ui-library';
import { isEmpty } from 'es-toolkit/compat';
import { getActiveUnitTemplateSelector } from 'client/store/entities/unit-templates/selectors';

export const UnitContext = createContext<{ [key: string]: string}>({});

export const UnitTemplateContextProvider = ({ children }: { children: ReactNode }) => {
  const unitTemplate = useSelector(getActiveUnitTemplateSelector) ?? {};
  useEffect(() => {
    if (!isEmpty(unitTemplate)) {
      initContextInGUI(UnitContext);
    }
  }, [unitTemplate]);

  return (
    //@ts-ignore
    <UnitContext.Provider value={unitTemplate}>
      {children}
    </UnitContext.Provider>
  );
};
